// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"647b9d69","80":"ead2f9b4","774":"e7d8643c","787":"4d29a204","820":"1025d927","883":"db345fbe","910":"9dddc4ae"}[chunkId] + ".chunk.js";
};